import styled from "@emotion/styled";

export const CopyrightContainer = styled.div({})

export const CopyrightText = styled.span({
    opacity: 0.5,
})